exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.vf-h {\r\n    overflow: hidden !important;\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-6c673692!./~/vue-loader/lib/selector.js?type=styles&index=1!./src/components/emapm-form/baseComponents/baseSelect/baseSelect.vue
// module id = 175
// module chunks = 0